import styles from "../styles/quick-access/quickAccess.module.scss"
import Image from "next/image"
import Button from "../src/components/Button/Button"
import { Routes, useTypedRouter } from "../src/data/routes"
import { TrackedActions } from "../src/tracking/trackedActions"
import SkinuvitaSeoHead from "../src/components/LandingPage/SkinuvitaSeoHead"

const QuickAccess = ({}) => {
  const router = useTypedRouter()

  return (
    <div className={styles.quickAccessRoot}>
      <SkinuvitaSeoHead
        title={"Skinuvita – alle Links auf einen Blick"}
        description={
          "Direkte Links zur Skinuvita Website, zum Selbst-Check, zum Ratgeber und zu unseren " +
          "Social-Media-Kanälen."
        }
        canonicalPath={Routes.quickAccess}
      />
      <Image
        src={"/Skinuvita_full_logo.svg"}
        width={151}
        height={151}
        alt={"Skinuvita logo"}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <div className={styles.ctaContainer}>
        <Button
          onClick={() => {
            router.push(Routes.home)
          }}
          variant={"secondaryCTA"}
          className={styles.cta}
        >
          zur Skinuvita Website
        </Button>{" "}
        <Button
          onClick={() => {
            void TrackedActions.goToSelfCheck()
          }}
          variant={"secondaryCTA"}
          className={styles.cta}
        >
          Ist Skinuvita eine Option für mich?
        </Button>
        <Button
          onClick={() => {
            router.push("/#contact")
          }}
          variant={"secondaryCTA"}
          className={styles.cta}
        >
          Kontakt aufnehmen
        </Button>
      </div>
      <div className={styles.logoButtons}>
        <a target={"_blank"} rel={"noreferrer"} href={"https://www.instagram.com/skinuvita/"}>
          <Image
            src={"/svg/instagram.svg"}
            alt={"instagram"}
            width={72}
            height={72}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </a>
        <a target={"_blank"} rel={"noreferrer"} href={"https://www.linkedin.com/company/skinuvita"}>
          <Image
            src={"/svg/linkedin.svg"}
            alt={"linkedin"}
            width={72}
            height={72}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </a>
        {/*<a href={"https://wa.me/+4942149951300"}>*/}
        {/*  <Image*/}
        {/*    src={"/svg/whatsapp.svg"}*/}
        {/*    alt={"whatsapp"}*/}
        {/*    width={72}*/}
        {/*    height={72}*/}
        {/*    style={{*/}
        {/*      maxWidth: "100%",*/}
        {/*      height: "auto",*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</a>*/}
      </div>
    </div>
  )
}

export default QuickAccess
